import { Badge, Box } from "@chakra-ui/react";

/** A soft pill with a colored dot, used for both task and document statuses. */
export function StatusPill({ colorScheme, label }: { colorScheme: string; label: string }) {
  return (
    <Badge
      alignItems="center"
      borderRadius="full"
      colorScheme={colorScheme}
      display="inline-flex"
      fontSize="xs"
      fontWeight="medium"
      gap={1.5}
      px={2.5}
      py={0.5}
      textTransform="none"
      whiteSpace="nowrap"
    >
      <Box bg={`${colorScheme}.500`} borderRadius="full" flexShrink={0} h="6px" w="6px" />
      {label}
    </Badge>
  );
}

export function TasksV2StatusBadge({
  status,
}: {
  status: "COMPLETED" | "INCOMPLETED" | "APPROVED" | null;
}) {
  switch (status) {
    case "APPROVED":
      return <StatusPill colorScheme="blue" label="Approved" />;
    case "COMPLETED":
      return <StatusPill colorScheme="green" label="Completed" />;
    case "INCOMPLETED":
      return <StatusPill colorScheme="gray" label="Incompleted" />;
    case null:
      return <StatusPill colorScheme="gray" label="Incompleted" />;
  }
}
